import React, { useCallback, useEffect } from "react";

import { Switch } from "@material-ui/core";
import { get } from "lodash";
import { useDataProvider } from "react-admin";

const FlagInput = ({ record, source }) => {
  const dataProvider = useDataProvider();
  const [value, setValue] = React.useState(get(record, source));
  const handleChange = useCallback(
    (e) => {
      setValue(e.target.checked);
      dataProvider.post("monitoring-experts/update", {
        id: record.id,
        [source]: e.target.checked,
      });
    },
    [dataProvider, record, source]
  );
  useEffect(() => setValue(get(record, source)), [record, source]);

  return <Switch value={value} checked={value} onChange={handleChange} />;
};
export default FlagInput;
